var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "90px",
    viewBox: "0 0 115 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "assets/video_player") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 88,
    width: 115,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 88,
    width: 101,
    height: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Take-the-video-tour---widget-Specification",
    transform: "translate(-179.000000, -328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(68.000000, 328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets/video_player",
    transform: "translate(111.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L113,0 C114.104569,-2.02906125e-16 115,0.8954305 115,2 L115,90 L115,90 L0,90 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Rectangle",
    fill: "#F4F4F8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F4F4F8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.0393356643,
    fill: "#000000",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#00336D",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.682552,
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45.2886434,25.4906996 L72.5693406,41.6964811 C74.233029,42.6847759 74.7819128,44.8369418 73.7953069,46.5034781 C73.4958612,47.00929 73.0742881,47.4315848 72.5693406,47.731543 L45.2886434,63.9373245 C43.624955,64.9256193 41.476467,64.3757959 40.4898611,62.7092596 C40.1692056,62.1676209 40,61.5495115 40,60.9197936 L40,28.5082305 C40,26.5706883 41.5680042,25 43.5022354,25 C44.1308772,25 44.7479304,25.1694953 45.2886434,25.4906996 Z",
    id: "Play",
    fill: "#92CAEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(902.000000, -10202.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5693406,41.6964811 C74.233029,42.6847759 74.7819128,44.8369418 73.7953069,46.5034781 C73.4958612,47.00929 73.0742881,47.4315848 72.5693406,47.731543 L45.2886434,63.9373245 C43.624955,64.9256193 41.476467,64.3757959 40.4898611,62.7092596 C40.1692056,62.1676209 40,61.5495115 40,60.9197936 L72.5693406,41.6964811 Z",
    id: "Play",
    fill: "#5587C6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/video-player.12887216c5cd400007c80f9d9e37fb84.svg";
export { ForwardRef as ReactComponent };